import React from "react";

import Header from "./Header";
import Aside from "./Aside";
import Footer from "./Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ModalForm from "./ModalForm";
import Loading from "./Loading";
import userPlaceholder from '../../../resources/img/user-default.jpg';

function CambioClave(props) {

    const [loggedIn, setLoggedIn] = useState(false);
    const [username, setUsername] = useState('');
    const [client, setClient] = useState([]);
    const [loading, setLoading] = useState(false);
    const [uid, setUid] = useState();
    const [errorlist, setErrorlist] = useState({});

    const [mensajePopup, setMensajePopup] = useState('Lorem ipsum dolor');
    const [claseMensajePopup, setClaseMensajePopup] = useState('alert alert-success mensaje-popup');
    
    const [currentPassword, setCurrentPassword] = useState();
    const [newPassword, setNewPassword] = useState();
    const [newPasswordConfirm, setNewPasswordConfirm] = useState();

    let userdata = [];
    let clientData = [];


    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
            setUid(userdata.user_id);
        }
    
        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }
    
        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setUsername(userdata.user_name);
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log(error);
            });
    },[]);


    const handleSubmit = (e) => {
        e.preventDefault();

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            id: userdata.user_id,
            current_password: currentPassword,
            new_password: newPassword,
            new_password_confirmation: newPasswordConfirm
        }
        
        axios.put('/change-password',config)
            .then(response => {
                setErrorlist({});
                setLoading(false);

                console.log('resultado: '+response.data.resultado);

                if (response.data.resultado!='0') {
                    setMensajePopup('La contraseña ha sido cambiada');
                    setClaseMensajePopup('alert alert-success mensaje-popup visible');
                    setTimeout(() => setClaseMensajePopup('alert alert-success mensaje-popup'),2000);

                    document.getElementById('currentPassword').value = "";
                    document.getElementById('newPassword').value = "";
                    document.getElementById('newPasswordConfirm').value = "";
                }
                else {
                    setErrorlist({ current_password: 'Contraseña no válida' });
                }

                
                console.log(response);
            })
            .catch(error => {
                setErrorlist(error.response.data.errors);
            })
          
    }



    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="profile" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="k0"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="k1">Cambiar Contraseña</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Cambiar mi contraseña</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            
                            <div className="row">

                                <div className="col-md-5">
                                    
                                    <form id="role-form" onSubmit={handleSubmit} autoComplete="off">
                                        
                                        <div className="form-group">
                                            <label htmlFor="currentPassword">Contraseña actual</label>
                                            <input type="password" name="currentPassword" className="form-control" id="currentPassword" onChange={(e) => setCurrentPassword(e.target.value)} />
                                            <div className="invalid-feedback visible">
                                                {errorlist.current_password}
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="newPassword">Nueva contraseña</label>
                                            <input type="password" name="newPassword" className="form-control" id="newPassword" onChange={(e) => setNewPassword(e.target.value)} />
                                            <div className="invalid-feedback visible">
                                                {errorlist.new_password}
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="newPasswordConfirm">Confirmar nueva contraseña</label>
                                            <input type="password" name="newPasswordConfirm" className="form-control" id="newPasswordConfirm" onChange={(e) => setNewPasswordConfirm(e.target.value)} />
                                            <div className="invalid-feedback visible">
                                                {errorlist.new_password_confirmation}
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <button type="submit" id="btn-submit" className="btn btn-primary">Guardar cambios</button>
                                        </div>
                                    </form>
                                    
                                </div>

                            </div>
                        </div>
                    </section>
                </div>
                <div className={claseMensajePopup}>{mensajePopup}</div>
                <Footer />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default CambioClave;